// class DynamicPortraitTracker {
//   constructor(options = {}) {
//     this.mediaGallery = options.mediaGallery || document.querySelector('media-gallery[data-presentation="tracker"]');
//     this.imageData = [];
//     this.imageElements = [];
//     this.currentIndex = 0;
//     this.isHovering = false;
//     this.isLoaded = false;
//     this.zoomIcon = null;
//     this.lastUpdateTime = 0;
//     this.updateThrottle = 16; // ~60fps
//     this.lastMouseX = 0;
    
//     // Configuration
//     this.config = {
//       loadingText: options.loadingText || 'Loading images...',
//       errorText: options.errorText || 'Failed to load images',
//       apiEndpoint: options.apiEndpoint || '/api/portrait-images',
//       ...options
//     };
    
//     if (this.mediaGallery) {
//       this.init();
//     }
//   }

//   async init() {
//     try {
//       this.loadImagesFromLiquid();
//       await this.createImageElements();
      
//       // Debug: log image count and middle index
//       // console.log('Total images:', this.imageElements.length);
//       // console.log('Middle index:', this.getMiddleIndex());
//       // console.log('Image data:', this.imageData.map((img, i) => ({ index: i, url: img.url.split('/').pop() })));
      
//       this.setupEventListeners();
//       // this.createBoundaryGuides(); // Add visual guides
//       // this.createZoomIcon();
//       // Set middle image as default
//       this.setActiveImage(this.getMiddleIndex());
//       this.isLoaded = true;
//       this.removeLoadingIndicator();
//     } catch (error) {
//       console.error('Failed to initialize portrait tracker:', error);
//       this.showError();
//     }
//   }

//   // Get the middle index of the image array
//   getMiddleIndex() {
//     return Math.floor(this.imageElements.length / 2);
//   }

//   loadImagesFromLiquid() {
//     // Get image data passed from Liquid template
//     const dataScript = this.mediaGallery.querySelector('script[type="application/json"][data-portrait-images]');
    
//     if (dataScript) {
//       try {
//         this.imageData = JSON.parse(dataScript.textContent);
//         // Sort images by position to ensure correct order
//         this.imageData.sort((a, b) => (a.position || 0) - (b.position || 0));
//       } catch (error) {
//         console.error('Failed to parse image data from Liquid:', error);
//         this.extractImagesFromDOM();
//       }
//     } else {
//       // Fallback: Extract images from existing DOM
//       this.extractImagesFromDOM();
//     }
    
//     // console.log('Loaded images in order:', this.imageData.map((img, i) => `${i}: pos=${img.position}`));
//   }

//   getProductId() {
//     // Extract product ID from page meta or URL
//     const metaProduct = document.querySelector('meta[name="product-id"]');
//     if (metaProduct) return metaProduct.content;
    
//     // Fallback: extract from URL or global variables
//     if (window.ShopifyAnalytics?.meta?.product?.id) {
//       return window.ShopifyAnalytics.meta.product.id;
//     }
    
//     return null;
//   }

//   extractImagesFromDOM() {
//     // Fallback: extract from existing slideshow structure
//     const existingImages = this.mediaGallery.querySelectorAll('img[src*="cdn.shopify.com"]');
//     this.imageData = Array.from(existingImages).map((img, index) => ({
//       id: index + 1,
//       url: img.src,
//       alt: img.alt || `Portrait view ${index + 1}`,
//       position: index
//     }));
//   }

//   async createImageElements() {
//     const container = this.mediaGallery.querySelector('.portrait-container') || this.createContainer();
    
//     // Clear existing content
//     container.innerHTML = '';
    
//     for (let i = 0; i < this.imageData.length; i++) {
//       const imageData = this.imageData[i];
//       const img = document.createElement('img');
      
//       img.className = 'portrait-image';
//       img.src = imageData.url;
//       img.alt = imageData.alt;
//       img.style.cssText = `
//         position: absolute;
//         width: 100%;
//         height: 100%;
//         object-fit: contain;  /* Changed from cover to contain */
//         opacity: 0;
//         top: 0;
//         left: 0;
//       `;
      
//       // Wait for image to load
//       await new Promise((resolve, reject) => {
//         img.onload = resolve;
//         img.onerror = () => {
//           resolve(); // Continue even if image fails
//         };
//       });
      
//       container.appendChild(img);
//       this.imageElements.push(img);
//     }
//   }

//   createContainer() {
//     const container = document.createElement('div');
//     container.className = 'portrait-container';
//     container.style.cssText = `
//       position: relative;
//       width: 100%;
//       height: 400px;
//       overflow: hidden;
//       cursor: crosshair;
//       background: #000;
//       border-radius: 8px;
//       box-sizing: border-box;
//     `;
//     this.mediaGallery.appendChild(container);
//     return container;
//   }

//   createBoundaryGuides() {
//     const container = this.mediaGallery.querySelector('.portrait-container');
//     if (!container) return;

//     const rect = container.getBoundingClientRect();
//     const numImages = this.imageElements.length;
    
//     // Create a guides container
//     const guidesContainer = document.createElement('div');
//     guidesContainer.className = 'boundary-guides';
//     guidesContainer.style.cssText = `
//       position: absolute;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       pointer-events: none;
//       z-index: 5;
//     `;

//     // Create vertical lines for each image boundary
//     for (let i = 0; i <= numImages; i++) {
//       const line = document.createElement('div');
//       const position = (i / numImages) * 100;
      
//       line.style.cssText = `
//         position: absolute;
//         top: 0;
//         left: ${position}%;
//         width: 2px;
//         height: 100%;
//         background: ${i === 0 || i === numImages ? 'rgba(255, 0, 0, 0.6)' : 'rgba(0, 255, 255, 0.4)'};
//         pointer-events: none;
//       `;
      
//       // Add label
//       const label = document.createElement('div');
//       label.textContent = i;
//       label.style.cssText = `
//         position: absolute;
//         top: 5px;
//         left: ${position}%;
//         transform: translateX(-50%);
//         background: rgba(0, 0, 0, 0.7);
//         color: white;
//         padding: 2px 6px;
//         border-radius: 3px;
//         font-size: 11px;
//         font-weight: bold;
//         pointer-events: none;
//       `;
      
//       guidesContainer.appendChild(line);
//       guidesContainer.appendChild(label);
//     }

//     container.appendChild(guidesContainer);
//   }

//   // createZoomIcon() {
//   //   const container = this.mediaGallery.querySelector('.portrait-container');
//   //   if (!container) return;

//   //   // Create a wrapper that won't block mouse events
//   //   const wrapper = document.createElement('div');
//   //   wrapper.style.cssText = `
//   //     position: absolute;
//   //     top: 12px;
//   //     right: 12px;
//   //     width: 40px;
//   //     height: 40px;
//   //     z-index: 10;
//   //     pointer-events: none;
//   //   `;

//   //   this.zoomIcon = document.createElement('div');
//   //   this.zoomIcon.className = 'portrait-zoom-icon';
//   //   this.zoomIcon.innerHTML = `
//   //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//   //       <circle cx="11" cy="11" r="8" stroke="white" stroke-width="2"/>
//   //       <path d="m21 21-4.35-4.35" stroke="white" stroke-width="2"/>
//   //       <line x1="8" y1="11" x2="14" y2="11" stroke="white" stroke-width="2"/>
//   //       <line x1="11" y1="8" x2="11" y2="14" stroke="white" stroke-width="2"/>
//   //     </svg>
//   //   `;
    
//   //   this.zoomIcon.style.cssText = `
//   //     width: 100%;
//   //     height: 100%;
//   //     background: rgba(0, 0, 0, 0.6);
//   //     border-radius: 50%;
//   //     display: flex;
//   //     align-items: center;
//   //     justify-content: center;
//   //     cursor: pointer;
//   //     backdrop-filter: blur(4px);
//   //     border: 1px solid rgba(255, 255, 255, 0.2);
//   //     pointer-events: auto;
//   //     transition: all 0.2s ease;
//   //   `;

//   //   // Add hover effects
//   //   this.zoomIcon.addEventListener('mouseenter', () => {
//   //     this.zoomIcon.style.background = 'rgba(0, 0, 0, 0.8)';
//   //     this.zoomIcon.style.transform = 'scale(1.1)';
//   //   });

//   //   this.zoomIcon.addEventListener('mouseleave', () => {
//   //     this.zoomIcon.style.background = 'rgba(0, 0, 0, 0.6)';
//   //     this.zoomIcon.style.transform = 'scale(1)';
//   //   });

//   //   // Add click event to open zoom modal
//   //   this.zoomIcon.addEventListener('click', (e) => {
//   //     e.stopPropagation();
//   //     this.openZoomModal();
//   //   });

//   //   wrapper.appendChild(this.zoomIcon);
//   //   container.appendChild(wrapper);
//   // }

//   // openZoomModal() {
//   //   // Check if ProductZoomModal is available
//   //   if (typeof window.ProductZoomModal !== 'undefined') {
//   //     const zoomModal = new window.ProductZoomModal({
//   //       maxWidth: '70vw',
//   //       maxHeight: '70vh',
//   //     });
//   //     zoomModal.open();
//   //   } else {
//   //     console.warn('ProductZoomModal not found. Make sure zoom-modal.js is loaded.');
//   //     // Fallback: try to load the zoom modal script
//   //     this.loadZoomModalScript();
//   //   }
//   // }

//   // loadZoomModalScript() {
//   //   const script = document.createElement('script');
//   //   script.src = '/assets/zoom-modal.js';
//   //   script.onload = () => {
//   //     if (typeof window.ProductZoomModal !== 'undefined') {
//   //       const zoomModal = new window.ProductZoomModal();
//   //       zoomModal.open();
//   //     }
//   //   };
//   //   script.onerror = () => {
//   //     console.error('Failed to load zoom modal script');
//   //   };
//   //   document.head.appendChild(script);
//   // }

//   setupEventListeners() {
//     const container = this.mediaGallery.querySelector('.portrait-container');
//     if (!container) return;

//     container.addEventListener('mouseenter', (e) => {
//       this.isHovering = true;
//     });

//     container.addEventListener('mouseleave', (e) => {
//       this.isHovering = false;
      
//       // Always reset to middle when leaving, no exceptions
//       this.setActiveImage(this.getMiddleIndex());
//     });

//     container.addEventListener('mousemove', (e) => {
//       if (this.isHovering && this.isLoaded) {
//         const rect = container.getBoundingClientRect();
//         this.lastMouseX = e.clientX - rect.left;
//         this.updateImageBasedOnCursor(e);
//       }
//     });
//   }

//   updateImageBasedOnCursor(event) {
//     // Throttle updates to prevent flickering
//     const now = Date.now();
//     if (now - this.lastUpdateTime < this.updateThrottle) {
//       return;
//     }
//     this.lastUpdateTime = now;

//     const container = this.mediaGallery.querySelector('.portrait-container');
//     const rect = container.getBoundingClientRect();
//     const x = event.clientX - rect.left;
    
//     // Add small deadzone at edges to prevent flickering
//     const deadzone = 2;
//     const clampedX = Math.max(deadzone, Math.min(x, rect.width - deadzone));
    
//     const relativeX = (clampedX - rect.width / 2) / (rect.width / 2);
//     const newIndex = this.getImageIndexFromPosition(relativeX);
    
//     if (newIndex !== this.currentIndex) {
//       this.setActiveImage(newIndex);
//     }
//   }

//   getImageIndexFromPosition(x) {
//     const normalizedX = (x + 1) / 2;
//     const index = Math.floor(normalizedX * this.imageElements.length);
//     return Math.min(Math.max(index, 0), this.imageElements.length - 1);
//   }

//   setActiveImage(index) {
//     if (index < 0 || index >= this.imageElements.length) return;
    
//     this.currentIndex = index;
    
//     // Hide all images
//     this.imageElements.forEach(img => {
//       img.style.opacity = '0';
//     });
    
//     // Show selected image
//     this.imageElements[index].style.opacity = '1';
//   }

//   removeLoadingIndicator() {
//     const loading = this.mediaGallery.querySelector('.loading-indicator');
//     if (loading) loading.remove();
//   }

//   showError() {
//     const container = this.mediaGallery.querySelector('.portrait-container') || this.createContainer();
//     container.innerHTML = `<div class="error-message" style="
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       height: 100%;
//       color: white;
//       font-size: 16px;
//     ">${this.config.errorText}</div>`;
//   }

//   // Public methods for external control
//   setImageByIndex(index) {
//     this.setActiveImage(index);
//   }

//   getCurrentImage() {
//     return this.imageData[this.currentIndex];
//   }

//   async reload() {
//     this.imageElements.forEach(img => img.remove());
//     this.imageElements = [];
//     this.imageData = [];
//     this.zoomIcon = null;
//     await this.init();
//   }
// }

// // Auto-initialize when DOM is ready
// document.addEventListener('DOMContentLoaded', () => {
//     if (window.innerWidth > 768) {
//         const trackerGalleries = document.querySelectorAll('media-gallery[data-presentation="tracker"]');
//         trackerGalleries.forEach(gallery => {
//             new DynamicPortraitTracker({ mediaGallery: gallery });
//         });
//     }
// });

// // Export for manual initialization
// window.DynamicPortraitTracker = DynamicPortraitTracker;

class UnifiedPortraitTracker {
  constructor(options = {}) {
    this.mediaGallery = options.mediaGallery || document.querySelector('media-gallery[data-presentation="tracker"]');
    this.imageData = [];
    this.currentIndex = 0;
    this.isLoaded = false;
    this.currentMode = null; // 'desktop' or 'mobile'
    this.container = null;
    this.imageElements = [];
    this.swipeIndicator = null;
    this.zoomIcon = null;
    
    // Desktop specific
    this.isHovering = false;
    this.lastUpdateTime = 0;
    this.updateThrottle = 16; // ~60fps
    this.lastMouseX = 0;
    
    // Mobile specific
    this.isDragging = false;
    
    // Configuration
    this.config = {
      breakpoint: 768, // Switch between mobile and desktop at this width
      loadingText: options.loadingText || 'Loading images...',
      errorText: options.errorText || 'Failed to load images',
      ...options
    };
    
    if (this.mediaGallery) {
      this.init();
      this.setupResizeListener();
    }
  }

  async init() {
    try {
      this.loadImagesFromLiquid();
      
      // Determine initial mode
      this.currentMode = this.isMobile() ? 'mobile' : 'desktop';
      
      // Create appropriate container and setup
      await this.setupMode(this.currentMode);
      
      this.isLoaded = true;
      this.removeLoadingIndicator();
    } catch (error) {
      console.error('Failed to initialize portrait tracker:', error);
      this.showError();
    }
  }

  isMobile() {
    return window.innerWidth <= this.config.breakpoint;
  }

  setupResizeListener() {
    let resizeTimer;
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newMode = this.isMobile() ? 'mobile' : 'desktop';
        
        // Only reinitialize if mode actually changed
        if (newMode !== this.currentMode) {
          console.log(`Switching from ${this.currentMode} to ${newMode} mode`);
          this.switchMode(newMode);
        }
      }, 250); // Debounce resize events

      if (typeof window.cursorCustom === 'function') {
        setTimeout(() => {
          window.cursorCustom();
        }, 300);
      }
    });
  }

  async switchMode(newMode) {
    // Clean up current mode
    this.cleanup();
    
    // Update mode
    this.currentMode = newMode;
    
    // Setup new mode
    await this.setupMode(newMode);
  }

  cleanup() {
    // Remove event listeners
    if (this.container) {
      const newContainer = this.container.cloneNode(false);
      this.container.parentNode?.replaceChild(newContainer, this.container);
      this.container = newContainer;
    }
    
    // Clear image elements array but keep the DOM images for reuse
    this.imageElements = [];
    this.isHovering = false;
    this.isDragging = false;
  }

  async setupMode(mode) {
    if (mode === 'mobile') {
      await this.setupMobile();
    } else {
      await this.setupDesktop();
    }
    
    // Set middle image as default for both modes
    this.setActiveImage(this.getMiddleIndex());
  }

  // ==================== DESKTOP MODE ====================
  async setupDesktop() {
    await this.createDesktopContainer();
    this.setupDesktopEventListeners();
  }

  async createDesktopContainer() {
    // Remove any existing containers
    const existingContainers = this.mediaGallery.querySelectorAll('.portrait-container, .tracker-container-mobile');
    existingContainers.forEach(c => c.remove());
    
    this.container = document.createElement('div');
    this.container.className = 'portrait-container';
    this.container.style.cssText = `
      position: relative;
      width: 100%;
      height: 550px;
      overflow: hidden;
      cursor: crosshair;
      background: #FFF;
      border-radius: 8px;
      box-sizing: border-box;
    `;
    
    // Create/reuse image elements
    for (let i = 0; i < this.imageData.length; i++) {
      const imageData = this.imageData[i];
      const img = document.createElement('img');
      
      img.className = 'portrait-image';
      img.src = imageData.url;
      img.alt = imageData.alt;
      img.style.cssText = `
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
        opacity: 0;
        top: 0;
        left: 0;
      `;
      
      // Wait for image to load
      await new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve;
        }
      });
      
      this.container.appendChild(img);
      this.imageElements.push(img);
    }
    
    this.mediaGallery.appendChild(this.container);
  }

  setupDesktopEventListeners() {
    this.container.addEventListener('mouseenter', () => {
      this.isHovering = true;
    });

    this.container.addEventListener('mouseleave', () => {
      this.isHovering = false;
      this.setActiveImage(this.getMiddleIndex());
    });

    this.container.addEventListener('mousemove', (e) => {
      if (this.isHovering && this.isLoaded) {
        const rect = this.container.getBoundingClientRect();
        this.lastMouseX = e.clientX - rect.left;
        this.updateImageBasedOnCursor(e);
      }
    });
  }

  updateImageBasedOnCursor(event) {
    const now = Date.now();
    if (now - this.lastUpdateTime < this.updateThrottle) {
      return;
    }
    this.lastUpdateTime = now;

    const rect = this.container.getBoundingClientRect();
    const x = event.clientX - rect.left;
    
    const deadzone = 2;
    const clampedX = Math.max(deadzone, Math.min(x, rect.width - deadzone));
    
    const relativeX = (clampedX - rect.width / 2) / (rect.width / 2);
    const newIndex = this.getImageIndexFromPosition(relativeX);
    
    if (newIndex !== this.currentIndex) {
      this.setActiveImage(newIndex);
    }
  }

  getImageIndexFromPosition(x) {
    const normalizedX = (x + 1) / 2;
    const index = Math.floor(normalizedX * this.imageElements.length);
    return Math.min(Math.max(index, 0), this.imageElements.length - 1);
  }

  // ==================== MOBILE MODE ====================
  async setupMobile() {
    await this.createMobileContainer();
    this.setupSwipeIndicator();
    this.setupMobileEventListeners();
    this.showSwipeIndicatorWithDelay();
  }

  async createMobileContainer() {
    // Remove any existing containers
    const existingContainers = this.mediaGallery.querySelectorAll('.portrait-container, .tracker-container-mobile');
    existingContainers.forEach(c => c.remove());
    
    this.container = document.createElement('div');
    this.container.className = 'tracker-container-mobile';
    this.container.style.cssText = `
      position: relative;
      width: 100%;
      aspect-ratio: 3 / 4;
      max-height: 80vh;
      min-height: 450px;
      background: #FFFFFF;
      overflow: hidden;
      touch-action: pan-y;
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    `;

    // Create/reuse image elements
    for (let i = 0; i < this.imageData.length; i++) {
      const imageData = this.imageData[i];
      const img = document.createElement('img');
      
      img.src = imageData.url;
      img.alt = imageData.alt;
      img.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        opacity: 0;
      `;
      
      this.container.appendChild(img);
      this.imageElements.push(img);
    }

    this.mediaGallery.appendChild(this.container);
  }

  setupSwipeIndicator() {
    this.swipeIndicator = document.querySelector('.mobile-swipe-indicator');
    
    if (!this.swipeIndicator) {
      return;
    }

    this.container.appendChild(this.swipeIndicator);
    
    this.swipeIndicator.style.display = 'block';
    this.swipeIndicator.style.position = 'absolute';
    this.swipeIndicator.style.bottom = '0';
    this.swipeIndicator.style.left = '50%';
    this.swipeIndicator.style.transform = 'translateX(-50%)';
    this.swipeIndicator.style.zIndex = '100';
    this.swipeIndicator.style.opacity = '0';
    this.swipeIndicator.style.transition = 'opacity 0.5s ease-in-out';
    this.swipeIndicator.style.pointerEvents = 'none';
    this.swipeIndicator.style.width = '60px';
  }

  showSwipeIndicatorWithDelay() {
    if (!this.swipeIndicator) return;
    
    setTimeout(() => {
      if (this.swipeIndicator && this.currentMode === 'mobile') {
        this.swipeIndicator.style.opacity = '1';
        
        setTimeout(() => {
          this.hideSwipeIndicator();
        }, 5000);
      }
    }, 1000);
  }

  hideSwipeIndicator() {
    if (this.swipeIndicator) {
      this.swipeIndicator.style.opacity = '0';
    }
  }

  setupMobileEventListeners() {
    let startX = 0;
    let startY = 0;
    let isHorizontalSwipe = false;

    // Touch start
    this.container.addEventListener('touchstart', (e) => {
      this.hideSwipeIndicator();
      
      if (e.target === this.zoomIcon || this.zoomIcon?.contains(e.target)) {
        return;
      }
      
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      this.isDragging = true;
      isHorizontalSwipe = false;
    }, { passive: true });

    // Touch move
    this.container.addEventListener('touchmove', (e) => {
      if (!this.isDragging) return;
      
      if (e.target === this.zoomIcon || this.zoomIcon?.contains(e.target)) {
        return;
      }
      
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const deltaX = Math.abs(currentX - startX);
      const deltaY = Math.abs(currentY - startY);
      
      if (!isHorizontalSwipe && deltaX > 10 && deltaY > 10) {
        isHorizontalSwipe = deltaX > deltaY;
      } else if (!isHorizontalSwipe && deltaX > 10) {
        isHorizontalSwipe = true;
      }
      
      if (isHorizontalSwipe) {
        const rect = this.container.getBoundingClientRect();
        const relativeX = (currentX - rect.left) / rect.width;
        const clampedX = Math.max(0, Math.min(1, relativeX));
        
        const imageIndex = Math.floor(clampedX * this.imageElements.length);
        const finalIndex = Math.min(imageIndex, this.imageElements.length - 1);
        
        if (finalIndex !== this.currentIndex) {
          this.setActiveImage(finalIndex);
        }
        
        e.preventDefault();
      }
    }, { passive: false });

    // Touch end
    this.container.addEventListener('touchend', () => {
      this.isDragging = false;
    }, { passive: true });

    // Mouse events for desktop testing
    this.container.addEventListener('mousedown', (e) => {
      this.hideSwipeIndicator();
      
      if (e.target === this.zoomIcon || this.zoomIcon?.contains(e.target)) {
        return;
      }
      
      startX = e.clientX;
      this.isDragging = true;
    });

    this.container.addEventListener('mousemove', (e) => {
      if (!this.isDragging) return;
      
      const rect = this.container.getBoundingClientRect();
      const relativeX = (e.clientX - rect.left) / rect.width;
      const clampedX = Math.max(0, Math.min(1, relativeX));
      
      const imageIndex = Math.floor(clampedX * this.imageElements.length);
      const finalIndex = Math.min(imageIndex, this.imageElements.length - 1);
      
      if (finalIndex !== this.currentIndex) {
        this.setActiveImage(finalIndex);
      }
    });

    this.container.addEventListener('mouseleave', () => {
      this.isDragging = false;
      this.setActiveImage(this.getMiddleIndex());
    });

    this.container.addEventListener('mouseup', () => {
      this.isDragging = false;
    });
  }

  // ==================== SHARED METHODS ====================
  getMiddleIndex() {
    return Math.floor(this.imageElements.length / 2);
  }

  loadImagesFromLiquid() {
    const dataScript = this.mediaGallery.querySelector('script[type="application/json"][data-portrait-images]');
    
    if (dataScript) {
      try {
        this.imageData = JSON.parse(dataScript.textContent);
        this.imageData.sort((a, b) => (a.position || 0) - (b.position || 0));
      } catch (error) {
        console.error('Failed to parse image data from Liquid:', error);
        this.extractImagesFromDOM();
      }
    } else {
      this.extractImagesFromDOM();
    }
  }

  extractImagesFromDOM() {
    const existingImages = this.mediaGallery.querySelectorAll('img[src*="cdn.shopify.com"]');
    this.imageData = Array.from(existingImages).map((img, index) => ({
      id: index + 1,
      url: img.src,
      alt: img.alt || `Portrait view ${index + 1}`,
      position: index
    }));
  }

  setActiveImage(index) {
    if (index < 0 || index >= this.imageElements.length) return;
    
    this.currentIndex = index;
    
    this.imageElements.forEach(img => {
      img.style.opacity = '0';
    });
    
    this.imageElements[index].style.opacity = '1';
  }

  removeLoadingIndicator() {
    const loading = this.mediaGallery.querySelector('.loading-indicator');
    if (loading) loading.remove();
    
    const desktopContainer = this.mediaGallery.querySelector('.desktop-only');
    if (desktopContainer) desktopContainer.remove();
  }

  showError() {
    if (!this.container) {
      this.container = document.createElement('div');
      this.mediaGallery.appendChild(this.container);
    }
    
    this.container.innerHTML = `<div class="error-message" style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: white;
      font-size: 16px;
    ">${this.config.errorText}</div>`;
  }

  // Public API
  setImageByIndex(index) {
    this.setActiveImage(index);
  }

  getCurrentImage() {
    return this.imageData[this.currentIndex];
  }

  destroy() {
    window.removeEventListener('resize', this.resizeHandler);
    this.cleanup();
    if (this.container) {
      this.container.remove();
    }
  }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const trackerGalleries = document.querySelectorAll('media-gallery[data-presentation="tracker"]');
  trackerGalleries.forEach(gallery => {
    new UnifiedPortraitTracker({ mediaGallery: gallery });
  });
});

// Also handle immediate initialization for previews
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(() => {
    const indicator = document.getElementById('cltrax9zywrb_preview');
    const classIndicator = document.querySelector('.cl-po--preview-wrapper');

    if (indicator || classIndicator) {
      const trackerGalleries = document.querySelectorAll('media-gallery[data-presentation="tracker"]');
      trackerGalleries.forEach(gallery => {
        new UnifiedPortraitTracker({ mediaGallery: gallery });
      });
    }
  }, 1000);
}

// Export for manual initialization
window.UnifiedPortraitTracker = UnifiedPortraitTracker;